<template>
 <Head>
    <title> Edit Staff Skill | {{$page.props.appName}}</title>
    <meta name="description" :content="'Edit Staff Skill ' + $page.props.appName">
  </Head>
      <div class="p-3 flex flex-wrap">
        <div
            class="bg-gray-100 rounded-md shadow overflow-hidden max-w-3xl p-3 mx-2"
        >
            <form @submit.prevent="false">
                <div class="p-8 -mr-6 -mb-8 flex flex-wrap">
                    <div class="pr-6 pb-8 w-full lg:w-1/2">
                        <label for="text-input-17" class="form-label"
                            >Skill Name:</label
                        >
                        <select class="form-select" v-model="this.form.staff_skills_id">
                          <option :value="skill.id" v-for="skill in skills" :key="skill.id">{{skill.skill_name}}</option>
                        </select>
                    </div>
                    <div class="pr-6 pb-8 w-full lg:w-1/2">
                        <label for="text-input-17" class="form-label"
                            >Achieved Date:</label
                        >
                        <input
                            v-model="this.form.achieved_date"
                            type="date"
                            class="form-input"
                        />
                    </div>
                    <div class="pr-6 pb-8 w-full lg:w-1/2">
                        <label for="text-input-17" class="form-label"
                            >Expired Date:</label
                        >
                        <input
                            v-model="this.form.expiry_date"
                            type="date"
                            class="form-input"
                        />
                    </div>
                </div>
                </form>

                <div class="w-full">
                    <button
                        class="
                            bg-red-400
                            text-white
                            font-bold
                            p-2
                            ml-6
                            mt-3
                            float-left
                        "
                        @click="deletedata()"
                    >
                        DELETE STAFF SKILL
                    </button>
                    <button
                        type="submit"
                        class="
                            bg-black
                            text-white
                            font-bold
                            p-2
                            ml-6
                            mt-3
                            float-right
                        "
                        :disabled="form.processing"
                        @click="store()"
                    >
                        EDIT STAFF SKILL
                    </button>
                </div>
        </div>

          <div
            class="bg-gray-100 rounded-md shadow overflow-hidden max-w-3xl p-3 mx-2"
        >
          <h1 class="font-semibold">Evidence</h1>
          <div class="p-2">
              <img class="inline" :src="'/evidence/' + evidence[0].document_name "  width="250" height="250" alt="" v-if="fronturl.length<=0">
              <img class="inline" :src="fronturl"  width="250" height="250" alt="" v-else>

              <input type="file" ref="front" class="hidden"  @change="onFrontChange" accept="image/*" >
             <button
                        type="submit"
                        class="
                            bg-black
                            text-white
                            font-bold
                            p-2
                            ml-6
                            mt-3
                        "
                        :disabled="form.processing"
                        @click="$refs.front.click()"
                    >
                      CHANGE EVIDENCE
                    </button>

          </div>
          <div class="p-2">
              <img class="inline" :src="'/evidence/' + evidence[1].document_name "  width="250" height="250" alt="" v-if="backurl.length<=0">
                <img class="inline" :src="backurl"  width="250" height="250" alt="" v-else>

              <input type="file" ref="back" class="hidden" @change="onBackChange" accept="image/*" >

             <button
                        type="submit"
                        class="
                            bg-black
                            text-white
                            font-bold
                            p-2
                            ml-6
                            mt-3
                        "
                        :disabled="form.processing"
                        @click="$refs.back.click()"

                    >
                      CHANGE EVIDENCE
                    </button>
          </div>

            
          </div>
    </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import Pagination from "@/Shared/Pagination";
import { Link } from "@inertiajs/inertia-vue3";
import moment from 'moment';
import { Head } from '@inertiajs/inertia-vue3'

export default {
    props: {
        skills : Object,
        staffskill: Object,
        id: String,
        evidence : Object,
    },
    layout: Layout,
    components: { Link, Pagination,Head},
    data() {
        return {
            fronturl: "",
            backurl: "",

            form: this.$inertia.form({
                staff_skills_id : this.staffskill.skill_id,
                achieved_date: moment(this.staffskill.achieved_date).format("Y-MM-DD"),
                expiry_date: moment(this.staffskill.expiry_date).format("Y-MM-DD"),
                front_card : null,
                back_card : null
            }),
        };
    },
    methods: {
        store() {
            this.form.post("/admin/skills/staffskill/edit/" + this.id);
        },
        deletedata() {
            if (confirm("Are you sure you want to delete this staff skill?")) {
                this.$inertia.delete("/admin/skills/staffskill/edit/" + this.id);
            }
        },
      onFrontChange(e) {
      const file = e.target.files[0];
      this.form.front_card = file;
      this.fronturl = URL.createObjectURL(file);
    },
     onBackChange(e) {
      const file = e.target.files[0];
      this.form.back_card = file;
      this.backurl = URL.createObjectURL(file);
    },
    },
};
</script>
